<template>
  <v-card class="com-pc-card rw-overview">
    <div>
      <v-row class="com-pc-card-header ov-header">
        <span class="com-pc-card-title pb-1">{{ text.title }}</span>
        <!-- 凡例 -->
        <v-tooltip
          v-if="this.tabIndex === 0 || this.tabIndex === 1"
          bottom
          max-width="450px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2 pb-1"
              >help_outline</v-icon
            >
          </template>
          <!-- 洪水予報 -->
          <span v-if="this.tabIndex === 0">
            {{ legendStr.fld.title }}
            <br />
            <span>
              <span>
                {{ legendStr.tmStg.tmStgMsg1 }}
                <br />
                {{ legendStr.tmStg.tmStgMsg2 }}
                <br />
              </span>
              <span class="text-flood-occurrence legend-stg-span mb-1">
                {{ legendStr.tmStg.occurrence }}
              </span>
              <br />
              <span class="text-flood-danger legend-stg-span mb-1">
                {{ legendStr.tmStg.danger }}</span
              >
              <br />
              <span class="text-flood-refuge legend-stg-span mb-1">
                {{ legendStr.tmStg.refuge }}
              </span>
              <br />
              <span class="text-flood-warn legend-stg-span mb-1">
                {{ legendStr.tmStg.warn }}
              </span>
            </span>
          </span>
          <!-- ダム放流通知 -->
          <span v-if="this.tabIndex === 1">
            {{ legendStr.dam.title }}
            <br />
            {{ legendStr.dam.damMsg1 }}
            <br />
            {{ legendStr.dam.damMsg2 }}
          </span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="pb-1"
              icon
              dark
              small
              @click="clickFullLink"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOn }}</span>
        </v-tooltip>
      </v-row>
    </div>

    <div class="rw-box com-pc-card-contents">
      <div class="tab">
        <!-- 表示切替タブ -->
        <v-btn
          class="com-btn mr-2"
          :class="rwBtnStates(0)"
          @click="clickTab(0)"
          >{{ text.floodFrecast }}</v-btn
        >
        <v-btn
          class="com-btn mr-2"
          :class="rwBtnStates(1)"
          @click="clickTab(1)"
          >{{ text.damNotification }}</v-btn
        >
        <v-btn
          v-if="isFldCtl"
          class="com-btn"
          :class="rwBtnStates(2)"
          @click="clickTab(2)"
          >{{ text.fldAlert }}</v-btn
        >
      </div>

      <v-row class="rw-box-ov">
        <!-- 模式図 -->
        <div class="rw-overview-map">
          <v-btn v-if="overviewLevel != 80" @click="retrunLevel()">
            <v-icon left>keyboard_arrow_left</v-icon>{{ text.return }}
          </v-btn>
          <object
            class="rw-overview-object"
            id="rw_overview"
            type="image/svg+xml"
            :data="overviewUrl"
          ></object>
        </div>
        <!-- 河川予警報一覧 -->
        <!-- 洪水予報一覧 -->
        <v-col class="rw-overview-list" v-if="tabIndex === 0">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist"
              v-if="!riverWarns.fldfr || riverWarns.fldfr.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.rwNoRegist
              }}</v-col
            >
            <v-list
              light
              v-for="(fldfr, fldfrIdx) in riverWarns.fldfr"
              :key="'fldfrIdx' + fldfrIdx"
              class="pa-0"
            >
              <v-list-item
                class="river-warn-list-line"
                @click="clickRiverWarnList(fldfr.type, fldfr.cd)"
              >
                <v-list-item-content>
                  <!-- 予警報名 -->
                  <v-list-item-title class="river-warn-title">
                    <span>{{ fldfr.nm }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="river-warn-sub-title">
                    <span
                      v-if="fldfr.lvl == 0"
                      class="text-flood-normal rw-span-warn-normal"
                      >{{ fldfr.kndNmM }}</span
                    >
                    <span v-if="fldfr.lvl == 30" class="text-flood-warn"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl2 }}</span
                    >
                    <span v-if="fldfr.lvl == 60" class="text-flood-refuge"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl3 }}</span
                    >
                    <span v-if="fldfr.lvl == 80" class="text-flood-danger"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl4 }}</span
                    >
                    <span v-if="fldfr.lvl == 90" class="text-flood-occurrence"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl5 }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title class="rw-new">
                    <!-- 新着 -->
                    <span v-if="isNew(fldfr.annTime)" class="icon-newcome">
                      {{ text.new }}
                    </span>
                  </v-list-item-title>
                  <!-- 発令予警報 -->
                  <v-list-item-subtitle class="river-warn-sub-title">
                    {{ getDispDate(fldfr.annTime) }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </v-col>
        <!-- ダム放流通知一覧 -->
        <v-col class="rw-overview-list" v-if="tabIndex === 1">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist"
              v-if="!riverWarns.damdsch || riverWarns.damdsch.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.rwNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(damdsch, damdschIdx) in riverWarns.damdsch"
              :key="'damdschIdx' + damdschIdx"
            >
              <v-list-item
                class="river-warn-list-line"
                @click="clickRiverWarnList(30, damdsch.damdschCd)"
              >
                <!-- アイコン -->
                <v-list-item-content>
                  <!-- 予警報名 -->
                  <v-list-item-title class="river-warn-title">
                    <span>{{ damdsch.damdschNm }}</span>
                  </v-list-item-title>
                  <!-- 発令予警報 -->
                  <v-list-item-subtitle class="river-warn-sub-title">
                    <span
                      v-if="damdsch.damdschLvl == 70"
                      class="text-damdsch-disasteroperating"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                    <span
                      v-if="damdsch.damdschLvl == 50"
                      class="text-damdsch-riserving"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                    <span
                      v-if="damdsch.damdschLvl == 0"
                      class="text-damdsch-normal rw-span-warn-normal"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <!-- 新着 -->
                  <v-list-item-title class="rw-new">
                    <span v-if="isNew(damdsch.annTime)" class="icon-newcome">{{
                      text.new
                    }}</span>
                  </v-list-item-title>
                  <!-- 発令時刻 -->
                  <v-list-item-subtitle class="river-warn-sub-title">
                    {{ getDispDate(damdsch.annTime) }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </v-col>
        <!-- 水防警報一覧 -->
        <v-col class="rw-overview-list" v-if="tabIndex === 2">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist"
              v-if="!riverWarns.fldctl || riverWarns.fldctl.length == 0"
            >
              {{ this.$store.state.app.config.messageConfig.rwNoRegist }}
            </v-col>
            <v-list
              class="pa-0"
              light
              v-for="(fldctl, fldctlIdx) in riverWarns.fldctl"
              :key="'fldctlIdx' + fldctlIdx"
            >
              <v-list-item
                class="river-warn-list-line"
                @click="clickRiverWarnList(20, fldctl.fldctlCd)"
              >
                <v-list-item-content>
                  <!-- 予警報名 -->
                  <v-list-item-title class="river-warn-title">
                    <span>{{ fldctl.fldctlNm }}</span>
                  </v-list-item-title>

                  <!-- 発令予警報 -->
                  <v-list-item-subtitle class="river-warn-sub-title">
                    <span
                      v-if="fldctl.fldctlLvl == 0"
                      class="text-fldctl-normal rw-span-warn-normal"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 10"
                      class="text-fldctl-standby"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 20"
                      class="text-fldctl-preparation"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 40"
                      class="text-fldctl-dispatch"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <!-- 新着 -->
                  <v-list-item-title class="rw-new">
                    <span v-if="isNew(fldctl.annTime)" class="icon-newcome">{{
                      text.new
                    }}</span>
                  </v-list-item-title>
                  <!-- 発令時刻 -->
                  <v-list-item-subtitle class="river-warn-sub-title">
                    {{ getDispDate(fldctl.annTime) }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
import { setTimeout } from "timers";
import color from "./../../scss/color.scss";
export default {
  name: "rw-overview",
  mixins: [mixin],
  data() {
    return {
      /** 河川予警報タブ選択値 */
      tabIndex: 0,
      /** 前回概況模式図の表示レベル */
      ovLevel: 0,
      /** スピナー表示[0:非表示,1:表示] */
      isLoading: 0,
      text: {
        title: "発表情報概況",
        floodFrecast: "洪水予報等",
        damNotification: "ダム放流通知",
        fldAlert: "水防警報",
        return: "戻る",
        new: "新着",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[RwOverview] mounted()");

    // パラメータによって初期表示するタブを変更
    let type = this.$route.query["type"];
    if (type === "fldfr") {
      this.tabIndex = 0;
    } else if (type === "damdsch") {
      this.tabIndex = 1;
    } else if (type === "fldctl") {
      this.tabIndex = 2;
    }

    let areaCd = this.$route.query["area"];
    this.$log.debug("[RwOverview] areaCd:" + areaCd);
    let prefCd = this.$route.query["pref"];
    this.$log.debug("[RwOverview] prefCd:" + prefCd);

    if (areaCd && prefCd) {
      setTimeout(() => {
        this.$store.dispatch("map/moveMapPrefecture", Number(prefCd));
        this.$store.commit("RiverWarn/setOverviewLevel", Number(areaCd));
      }, 200);
    } else if (areaCd) {
      setTimeout(() => {
        this.$store.dispatch("map/moveMapRegion", Number(areaCd));
        this.$store.commit("RiverWarn/setOverviewLevel", Number(areaCd));
      }, 200);
    }

    this.getRiverWarns();
    this.getRiverWarnsLvl();
  },
  computed: {
    /** 概況模式図の表示レベル */
    overviewLevel: {
      get() {
        return this.$store.state.RiverWarn.overviewLevel;
      },
    },
    /** 概況模式図のSVGのURL */
    overviewUrl: {
      get() {
        const level = this.$store.state.RiverWarn.overviewLevel;
        let url = this.$store.state.RiverWarn.overviewUrl;
        url = url + "/" + level + ".svg";
        return url;
      },
    },
    /** 概況模式図の地方毎のステータス */
    overviewState: {
      get() {
        return this.$store.state.RiverWarn.overviewState;
      },
    },
    /** 表示範囲の河川予警報データ */
    riverWarns: {
      get() {
        return this.$store.state.RiverWarn.riverWarnsOvList;
      },
    },
    /**
     * 表示範囲の河川予警報データパラメータ
     */
    riverWarnsParam: {
      get() {
        return this.$store.state.RiverWarn.riverWarnsOvParam;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRoundRw,
          towns: this.$store.state.map.towns,
          prefs: this.$store.state.map.prefs,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
  },
  methods: {
    /**
     * タブクリック
     */
    clickTab(index) {
      this.$log.debug("[RwOverview] clickTab(" + index + ")");
      this.tabIndex = index;
      let type = "";
      let pLogNm = "";
      if (index === 0) {
        type = "fldfr";
        pLogNm = "oview_ff";
      } else if (index === 1) {
        type = "damdsch";
        pLogNm = "oview_dd";
      } else if (index === 2) {
        type = "fldctl";
        pLogNm = "oview_fc";
      }
      // アクセスログ出力
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.type = type;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 河川予警報リスト選択
     */
    clickRiverWarnList(type, cd) {
      this.$log.debug(
        "[RwOverview] clickRiverWarnList(" + type + "," + cd + ")"
      );
      switch (type) {
        case "fldfr":
          type = 10;
          break;
        case "evstg":
          type = 11;
          break;
      }
      // ストアに予警報ID、予警報タイプを設定
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        type: type,
        cd: cd,
      });
      // 河川予警報画面に遷移
      this.routerPushRw("/pc/rw");
    },
    /**
     * 概況模式図を表示色を反映
     */
    setRwOvSvg() {
      this.$log.debug("[RwOverview] setRwOvSvg()");
      const elmE = document.getElementById("rw_overview");
      const elm = elmE.contentDocument;

      let ovState;
      if (this.overviewLevel === 80) {
        this.$log.debug("[RwOverview] setRwOvSvg overviewLevel === 80");
        // 全国レベルのSVG初期化
        if (this.tabIndex === 0) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 0");
          ovState = this.overviewState.area.fldfr;
        } else if (this.tabIndex === 1) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 1");
          ovState = this.overviewState.area.damdsch;
        } else if (this.tabIndex === 2) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 2");
          ovState = this.overviewState.area.fldctl;
        }

        // イベント張り付け
        for (const area of this.$store.state.app.config.mapConfig
          .regionLatLngList) {
          const pathElm = elm.getElementById(area.areaCd);
          if (pathElm == null) {
            continue;
          }
          pathElm.style.cursor = "pointer";
          pathElm.style.setProperty("fill", "#fff");

          // 概況模式図のクリックイベントを登録
          pathElm.addEventListener("click", () => {
            this.$log.debug(
              "[RwOverview] setRwOvSvg click(" + area.areaCd + ")"
            );
            let setQuery = Object.assign({}, this.$route.query);
            delete setQuery.pref;
            setQuery.area = area.areaCd;
            this.$router.replace({
              path: this.$route.path,
              query: setQuery,
            });
            this.$store.dispatch("map/moveMapRegion", area.areaCd);
            this.$store.commit("RiverWarn/setOverviewLevel", area.areaCd);
          });
        }
        this.ovLevel = this.overviewLevel;
      } else {
        this.$log.debug("[RwOverview] setRwOvSvg overviewLevel !== 80");
        // 地方レベルのSVG初期化
        if (this.tabIndex === 0) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 0");
          ovState = this.overviewState.pref.fldfr;
        } else if (this.tabIndex === 1) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 1");
          ovState = this.overviewState.pref.damdsch;
        } else if (this.tabIndex === 2) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 2");
          ovState = this.overviewState.pref.fldctl;
        }

        // イベント張り付け
        for (const pref of this.$store.state.app.config.mapConfig
          .prefLatLngList) {
          const pathElm = elm.getElementById(pref.prefCd);
          if (pathElm == null) {
            continue;
          }
          pathElm.style.cursor = "pointer";
          pathElm.style.setProperty("fill", "#fff");

          // 概況模式図のクリックイベントを登録
          pathElm.addEventListener("click", () => {
            this.$log.debug(
              "[RwOverview] setRwOvSvg click(" + pref.prefCd + ")"
            );
            let setQuery = Object.assign({}, this.$route.query);
            setQuery.area = this.overviewLevel;
            setQuery.pref = pref.prefCd;
            this.$router.replace({
              path: this.$route.path,
              query: setQuery,
            });
            this.$store.dispatch("map/moveMapPrefecture", pref.prefCd);
          });
        }
        this.ovLevel = this.overviewLevel;
      }

      for (const st of ovState) {
        var pathElm;
        if (this.overviewLevel === 80) {
          pathElm = elm.getElementById(st.areaCd);
        } else {
          pathElm = elm.getElementById(st.prefCd);
        }
        if (pathElm == null) {
          continue;
        }
        pathElm.style.cursor = "pointer";

        if (this.tabIndex === 0) {
          // 洪水予報
          switch (st.lvl) {
            case 30:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 30"
              );
              pathElm.style.setProperty("fill", color.stageWarning);
              break;
            case 60:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 60"
              );
              pathElm.style.setProperty("fill", color.stageRefuge);
              break;
            case 80:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 80"
              );
              pathElm.style.setProperty("fill", color.stageDanger);
              break;
            case 90:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 90"
              );
              pathElm.style.setProperty("fill", color.stageOver);
              break;
          }
        } else if (this.tabIndex === 1) {
          // ダム放流通知
          switch (st.lvl) {
            case 50:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 1, lvl === 50"
              );
              pathElm.style.setProperty("fill", color.damdschStorop);
              break;
            case 70:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 1, lvl === 70"
              );
              pathElm.style.setProperty("fill", color.damdschPrevop);
              break;
          }
        } else if (this.tabIndex === 2) {
          // 水防警報
          switch (st.lvl) {
            case 10:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 10"
              );
              pathElm.style.setProperty("fill", color.fldctlStandby);
              break;
            case 20:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 20"
              );
              pathElm.style.setProperty("fill", color.fldctlPreparation);
              break;
            case 40:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 40"
              );
              pathElm.style.setProperty("fill", color.fldctlDispatch);
              break;
          }
        }
      }
    },
    /**
     * 全国レベルへ戻る
     */
    retrunLevel() {
      this.$log.debug("[RwOverview] retrunLevel()");
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.area = 80;
      delete setQuery.pref;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
      this.$store.dispatch("map/moveMapNationwide");
      this.$store.commit("RiverWarn/setOverviewLevel", 80);
    },
    /**
     * 表示範囲の河川予警報一覧取得を取得
     */
    getRiverWarns() {
      this.$log.debug("[RwOverview] getRiverWarns()");
      // 河川予警報観測日時、市町村リスト取得時刻が変更された場合にAPIを取得
      if (
        new Date(this.reqParam.appTime).getTime() !=
          new Date(
            this.$store.state.RiverWarn.riverWarnsOvParam.dispTime
          ).getTime() ||
        new Date(this.reqParam.townsAcqTime).getTime() !=
          new Date(
            this.$store.state.RiverWarn.riverWarnsOvParam.townsAcqTime
          ).getTime()
      ) {
        // アクセスログ出力
        // ログ名称設定
        let pLogNm = "";
        if (this.tabIndex == 0) pLogNm = "oview_ff";
        if (this.tabIndex == 1) pLogNm = "oview_dd";
        if (this.tabIndex == 2) pLogNm = "oview_fc";
        PageLog.log({
          page_log: pLogNm,
          lat: this.$store.state.map.center[0],
          lon: this.$store.state.map.center[1],
          zm: this.$store.state.map.zoom,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
        this.isLoading = 1;
        setTimeout(() => {
          if (this.$store.state.map.prefTownType === "pref") {
            this.$store.dispatch("RiverWarn/getRiverwarnsListPref", {
              appTime: this.reqParam.appTime,
              prefs: this.reqParam.prefs,
              townsAcqTime: this.reqParam.townsAcqTime,
            });
          } else {
            this.$store.dispatch("RiverWarn/getRiverWarnsListTwn", {
              appTime: this.reqParam.appTime,
              prefs: this.reqParam.prefs,
              towns: this.reqParam.towns,
              townsAcqTime: this.reqParam.townsAcqTime,
            });
          }
        }, 500);
      }
    },
    /**
     * 模式図の河川予警報危険度を取得
     */
    getRiverWarnsLvl() {
      this.$log.debug("[RwOverview] getRiverWarnsLvl()");
      setTimeout(() => {
        this.$store.dispatch("RiverWarn/getRiverWarnsLvl", {
          appTime: this.reqParam.appTime,
        });
      }, 500);
    },
    /**
     * 全体表示ボタンクリック
     */
    clickFullLink() {
      this.$log.debug("[RwOverview] clickFullLink()");
      this.$store.commit("app/setPcPanelMode", true);
      this.$store.commit("app/setPcPanelModeContent", "RwList");

      let setQuery = Object.assign({}, this.$route.query);
      setQuery.ext = "1";
      setQuery.ovmd = "rw";
      this.$router.push({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(annTime) {
      this.$log.debug("[RwOverview] getDispDate(" + annTime + ")");
      return util.formatDate24(annTime, "MM/DD HH:mm");
    },
    /**
     * 新着表示有無
     */
    isNew(annTime) {
      this.$log.debug("[RwOverview] isNew(" + annTime + ")");
      let time = util.toDate(annTime);
      let addTime = util.addDate(
        time,
        0,
        this.$store.state.app.config.riverWarnConfig.isNewTime,
        0
      );
      if (this.$store.state.app.appTime <= addTime) {
        this.$log.debug("[RwOverview] isNew = true");
        return true;
      } else {
        this.$log.debug("[RwOverview] isNew = false");
        return false;
      }
    },
    /**
     * 予警報種別ボタン点滅
     */
    rwBtnStates(idx) {
      this.$log.debug("[RwOverview] rwBtnStates(" + idx + ")");
      // 選択中の予警報
      if (idx === this.tabIndex) {
        return "com-btn-on";
        // 選択していない予警報で発令中の場合に点滅
      } else if (
        idx === 0 &&
        this.riverWarns.fldfr &&
        this.riverWarns.fldfr.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 1 &&
        this.riverWarns.damdsch &&
        this.riverWarns.damdsch.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 2 &&
        this.riverWarns.fldctl &&
        this.riverWarns.fldctl.length > 0
      ) {
        return "com-btn-flash";
      }
    },
  },
  watch: {
    /**
     * 概況模式図の地方毎のステータス変更時
     */
    overviewState() {
      this.$log.debug("[RwOverview] watch(overviewState)");
      setTimeout(() => {
        this.setRwOvSvg();
      }, 2000);
    },
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[RwOverview] watch(reqParam)");
      this.getRiverWarns();
      this.getRiverWarnsLvl();
    },
    /**
     * 河川予警報タブ変更時
     */
    tabIndex() {
      this.$log.debug("[RwOverview] watch(tabIndex)");
      this.setRwOvSvg();
    },
    /**
     * 表示範囲の河川予警報データ
     */
    riverWarns() {
      this.$log.debug("[RwOverview] watch(riverWarns)");
      this.isLoading = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../scss/kwb.scss";

.rw-overview {
  display: flex;
  flex-direction: column;
  height: 100%;

  .ov-header {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  .rw-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    .tab {
      display: flex;
      flex-direction: row;
      padding: 8px;
    }

    .rw-box-ov {
      padding-right: 12px;
      height: 100%;

      .rw-overview-map {
        height: 230px;
        width: 200px;
        margin-left: 12px;

        .rw-overview-object {
          background: #bfd3ff;
        }
      }

      .rw-overview-list {
        height: 230px;
        overflow-y: auto;

        .rw-no-regist {
          font-size: 1rem;
        }
      }
    }
  }
}
.river-warn-title {
  span {
    display: inline-block;
    white-space: pre-wrap;
  }
}

.river-warn-sub-title {
  font-size: 10pt;
  span {
    margin-top: 2px;
    padding: 4px 4px 4px 4px;
    display: inline-block;
    border-radius: 4px;
    white-space: pre-line;
    font-size: 10pt;
  }

  .rw-span-warn-normal {
    padding: 4px 4px 4px 4px;
    border: solid 1px black;
  }
}

.rw-new {
  width: 100%;
  span {
    font-size: 10pt;
    font-weight: bold;
    display: inline-block;
    padding: 0px 4px 2px 4px;
    border-radius: 4px;
  }
}

.rw-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.rw-span-warn {
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
}

.rw-legend-img {
  width: 100%;
}
</style>
